var React = require('react');

function IconLocation (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M12.8888 21.12C14.8125 18.7125 19.2 12.8775 19.2 9.60002C19.2 5.62502 15.975 2.40002 12 2.40002C8.02505 2.40002 4.80005 5.62502 4.80005 9.60002C4.80005 12.8775 9.18755 18.7125 11.1113 21.12C11.5725 21.6938 12.4275 21.6938 12.8888 21.12ZM12 7.20002C12.6366 7.20002 13.247 7.45288 13.6971 7.90297C14.1472 8.35305 14.4 8.9635 14.4 9.60002C14.4 10.2365 14.1472 10.847 13.6971 11.2971C13.247 11.7472 12.6366 12 12 12C11.3635 12 10.7531 11.7472 10.303 11.2971C9.8529 10.847 9.60005 10.2365 9.60005 9.60002C9.60005 8.9635 9.8529 8.35305 10.303 7.90297C10.7531 7.45288 11.3635 7.20002 12 7.20002Z"}));
}

IconLocation.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconLocation;

IconLocation.default = IconLocation;
